import { z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { UuidSchema } from '../../common/id/id';
import { makeListQuery } from '../../common/list-query/list-query';
import { IapStoreSchema } from '../iap-store/iap-store';
import { ProductKeySchema } from '../product-key/product-key';

/**
 * The offer-code list's filters (N7).
 *
 * `discountRuleId` is the filter that matters: the question an operator actually
 * arrives with is "this rule changed — which store codes now need editing by
 * hand?", and answering it is the only mitigation the manual-mirroring
 * limitation has.
 *
 * `search` matches the **code**, not a name. The rule's and product's names are
 * resolved for display over the QueryBus after the page is selected, so they are
 * not columns here and cannot be searched without a cross-module read (N6).
 */
export const IapOfferCodeMappingsListQuerySchema = makeListQuery({
  discountRuleId: UuidSchema.optional(),
  productKey: ProductKeySchema.optional(),
  store: IapStoreSchema.optional(),
  isActive: BooleanParamSchema.optional(),
  search: z.string().trim().min(1).optional(),
});

export type IapOfferCodeMappingsListQuery = z.infer<typeof IapOfferCodeMappingsListQuerySchema>;
